<template>
    <div>
        <el-dialog class="dialogDiv" :close-on-click-modal="false" :modal-append-to-body='false' :title="dialogTitle"
            :visible.sync="cityDialogVisible" :before-close="handleCloseDialog">
            <el-form :model="cityAdd" :rules="dataRules" ref="cityAdd" class="ml20 mr20" label-position="left"
                label-width="120px" v-loading="formLoading">
                <el-form-item label="城市名称" prop="areaName">
                    <div v-if="this.cityData.type === 'isDetail'">{{cityAdd.areaName}}</div>
                    <div v-else>
                        <el-input class="w200" v-model="cityAdd.areaName" placeholder="请输入城市名称, 如: 成都市"></el-input>
                        <el-button class="fr" :disabled="cityAdd.areaName ===''" @click="locate"
                            style="margin-top:3px; margin-right:500px" type="warning" icon="el-icon-location">定位
                        </el-button>
                    </div>
                </el-form-item>
                <el-form-item label="区域编码" prop="areaId">
                    <div v-if="this.cityData.type === 'isDetail'">{{cityAdd.areaId}}</div>
                    <el-input class="w300" v-else v-model="cityAdd.areaId" placeholder="请输入区域编码, 如: 510100"></el-input>
                </el-form-item>
                <el-form-item label="经度" prop="lng">
                    <div v-if="this.cityData.type === 'isDetail'">{{cityAdd.lng}}</div>
                    <el-input v-else class="w300" v-model="cityAdd.lng" placeholder="请输入经度"></el-input>
                </el-form-item>
                <el-form-item label="纬度" prop="lat">
                    <div v-if="this.cityData.type === 'isDetail'">{{cityAdd.lat}}</div>
                    <el-input class="w300" v-else v-model="cityAdd.lat" placeholder="请输入纬度"></el-input>
                </el-form-item>
                <el-form-item label="小程序类型" prop="miniAppType">
                    <div v-if="this.cityData.type === 'isDetail'">{{cityAdd.miniAppType_}}</div>
                    <el-select class="w300" multiple v-else v-model="cityAdd.miniAppType" placeholder="请选择小程序类型"
                        clearable size="small">
                        <el-option v-for="(val,key) in miniAppType" :key="key" :label="val" :value="key"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="是否启用" prop="available">
                    <div v-if="this.cityData.type === 'isDetail'">{{cityAdd.available == 1 ? '启用' : '禁用'}}</div>
                    <el-switch v-else v-model="cityAdd.available" :active-value="1" :inactive-value="0" active-text="是"
                        inactive-text="否" style="margin-left:-26px"></el-switch>
                </el-form-item>
            </el-form>
            <div v-if="this.cityData.type !== 'isDetail'" id="container"></div>
            <div class="footer" v-if="this.cityData.type !== 'isDetail'">
                <el-button @click="cancle" round>关闭</el-button>
                <el-button type="primary" @click="submit('cityAdd')" round>保存</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    var geocoder;
    var marker;
    var map;
    import * as cityApi from '@/api/city'
    export default {
        name: 'CityDialog',
        data() {
            return {
                miniAppType: {
                    'FXSA': '放心食安',
                    'XCWS': '校餐卫士',
                    'HNYSA': '河南豫食安'
                },
                dialogTitle: '添加开通城市',
                dialogVisible: false,
                formLoading: false,
                cityAdd: {
                    areaId: "",
                    areaName: "",
                    available: null,
                    id: "",
                    lat: null,
                    lng: null,
                    miniAppType: []
                },
                dataRules: {
                    areaName: [{
                        required: true,
                        message: '请输入城市名称, 如: 成都市',
                        trigger: 'blur'
                    }],
                    areaId: [{
                        required: true,
                        message: '请输入区域编码, 如: 510100',
                        trigger: 'blur'
                    }],
                    lng: [{
                        required: true,
                        message: '请输入经度',
                        trigger: 'blur'
                    }],
                    lat: [{
                        required: true,
                        message: '请输入纬度',
                        trigger: 'blur'
                    }]
                    ,miniAppType:[{
                        required: true,
                        message: '至少选择一个小程序类型',
                        trigger: 'blur'
                    }]
                }
            }
        },
        props: {
            cityDialogVisible: {
                required: true,
                type: Boolean
            },
            cityData: {
                type: Object,
                required: true
            }
        },
        computed: {
            queryParams: function () {
                return {
                    areaId: this.cityAdd.areaId,
                    areaName: this.cityAdd.areaName,
                    available: this.cityAdd.available,
                    id: this.cityAdd.id,
                    lat: this.cityAdd.lat,
                    lng: this.cityAdd.lng,
                    miniAppType: this.cityAdd.miniAppType.toString()
                }
            }
        },
        methods: {
            locate() {
                let city = this.cityAdd.areaName;
                if (!city) return;
                let that = this;
                AMap.plugin('AMap.Geocoder', function () {
                    geocoder = new AMap.Geocoder({
                        // city 指定进行编码查询的城市，支持传入城市名、adcode 和 citycode
                        city: city
                    })
                    geocoder.getLocation(city, function (status, result) {
                        if (status === 'complete' && result.info === 'OK') {
                            // result中对应详细地理坐标信息
                            that.cityAdd.lng = result.geocodes[0].location.lng;
                            that.cityAdd.lat = result.geocodes[0].location.lat;
                            // that.cityAdd.areaId = result.geocodes[0].adcode;
                            that.cityAdd.areaName = result.geocodes[0].addressComponent.city;
                            map.setCity(city);
                        } else {
                            that.$message.warning('定位失败! 请输入正确的城市名或点击地图获取')
                        }
                    })
                })
            },
            mapShowFun() {
                setTimeout(() => {
                    map = new AMap.Map('container', {
                        resizeEnable: false, //是否监控地图容器尺寸变化
                    });
                    let that = this;
                    AMap.event.addListener(map, 'click', function (e) { //添加点击事件,传入对象名，事件名，回调函数
                        if (marker) {
                            map.remove(marker);
                        }
                        AMap.plugin('AMap.Geocoder', function () {
                            geocoder = new AMap.Geocoder({})
                            var lnglat = [e.lnglat.getLng(), e.lnglat.getLat()]
                            geocoder.getAddress(lnglat, function (status, result) {
                                if (status === 'complete' && result.info === 'OK') {
                                    // result为对应的地理位置详细信息
                                    that.cityAdd.lng = e.lnglat.getLng();
                                    that.cityAdd.lat = e.lnglat.getLat();
                                    that.cityAdd.areaId = result.regeocode
                                        .addressComponent.adcode;
                                    that.cityAdd.areaName = result.regeocode
                                        .addressComponent.city;
                                }
                            })
                        })
                        that.addMarker(e);
                        // map.setFitView();
                    })
                }, 100)
            },
            addMarker(e) {
                let icon = new AMap.Icon({
                    size: new AMap.Size(30, 40), // 图标尺寸
                    image: 'http://a.amap.com/jsapi_demos/static/demo-center/icons/poi-marker-red.png', // Icon的图像
                    imageOffset: new AMap.Pixel(0, 0), // 图像相对展示区域的偏移量，适于雪碧图等
                    imageSize: new AMap.Size(30, 40) // 根据所设置的大小拉伸或压缩图片
                });
                marker = new AMap.Marker({
                    icon: icon,
                    position: [e.lnglat.getLng(), e.lnglat.getLat()],
                    offset: new AMap.Pixel(-10, -40)
                });
                marker.setMap(map);
                marker.setAnimation('AMAP_ANIMATION_DROP');
            },
            getDetail(type) {
                this.formLoading = true;
                cityApi.getCityDetail({
                    id: this.cityData.id
                }).then(r => {
                    if (r.code === 200) {
                        this.cityAdd = r.data;
                        this.cityAdd.miniAppType = this.cityAdd.miniAppType.split(",")
                        if (this.cityAdd.areaName) {
                            map.setCity(this.cityAdd.areaName);
                        }
                        if (type == 'isDetail') {
                            this.cityAdd.miniAppType_ = '';
                            this.cityAdd.miniAppType.map(item => {
                                this.cityAdd.miniAppType_=this.cityAdd.miniAppType_+this.miniAppType[item]+','
                            })
                        }
                    }
                    this.formLoading = false;
                }).catch(e => {})
            },
            submit(cityAdd) {
                this.$refs[cityAdd].validate((valid) => {
                    if (valid) {
                        if (this.cityData.type === 'isAdd') {
                            cityApi.addCity(this.queryParams).then(r => {
                                if (r.code === 200) {
                                    this.$message.success('添加成功!')
                                    this.$parent.getCityList();
                                    this.handleCloseDialog();
                                }
                            }).catch(e => {})
                        } else if (this.cityData.type === 'isEdit') {
                            cityApi.editCity(this.queryParams).then(r => {
                                if (r.code === 200) {
                                    this.$message.success('编辑成功!')
                                    this.$parent.getCityList();
                                    this.handleCloseDialog();
                                }
                            }).catch(e => {})
                        }
                    };
                });
            },
            cancle() {
                this.handleCloseDialog();
            },
            handleCloseDialog() {
                this.$emit('closeCityDialog');
            }
        },
        mounted() {
            if (this.cityData.type === 'isAdd') { // 添加

            } else if (this.cityData.type === 'isEdit') { // 编辑
                this.dialogTitle = '编辑开通城市';
                this.getDetail();
            } else if (this.cityData.type === 'isDetail') { // 详情
                this.dialogTitle = '开通城市详情';
                this.getDetail('isDetail');
            }
            this.mapShowFun();
        }
    }
</script>

<style lang="scss" scoped>
    .dialogDiv::v-deep .el-dialog {
        width: 1000px;
    }

    .footer {
        // margin-top: 20px;
        text-align: right;
    }

    #container {
        margin-top: -375px;
        float: right;
        width: 500px;
        height: 352px;
    }
</style>